import React from 'react';
import { TimePicker } from 'material-ui-pickers';
import { buildTime, formatTime } from '../../../components/utils/DateUtils';

function SMTimePicker (props) {
    const handleDateChange = selectedDate => {
        const date = selectedDate ? formatTime(selectedDate) : selectedDate;
        const name = props.name || '';
        return props.onDateSelect({ date, name });
    };

    return (
        <TimePicker
            name={props.name}
            label={props.label}
            margin={props.margin}
            helperText={props.helperText}
            InputLabelProps={props.InputLabelProps}
            fullWidth
            clearable={props.clearable || true}
            value={buildTime(props.value)}
            onChange={handleDateChange}
            disabled={props.disabled}
        />
    );
}

export default SMTimePicker;
